import React, { useState } from "react"
import { CardText, Col, Row, Button } from "reactstrap"
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"
import DPAlert from "framework/widgets/DPAlert"
import Switch from "react-switch"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import ReactPaginate from "react-paginate"

const Offsymbol = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 12,
                color: "#fff",
                paddingRight: 2,
            }}
        >
            {" "}
            No
        </div>
    )
}

const OnSymbol = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 12,
                color: "#fff",
                paddingRight: 2,
            }}
        >
            {" "}
            Yes
        </div>
    )
}

const UserMasterTab4 = ({
    DataRow,
    disabled,
    menuCode,
    CheckAdmin,
    setVasRow,
    currentPage,
    setCurrentPage
}) => {


    const [alertShow, setsweetAlertShow] = useState(false)
    const [alertDesc, SetAlertDesc] = useState("")

    const [postsPerPage] = useState(10)

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    /**
        * @description This function is used to change the value of perticular field in perticular row.
        * @param {string} value - value of the row.
        * @param {string} id - id of the row.
        * @param {string} element - element of the row.
     */

    const changeRowValueChanges = (value, id, element) => {
        const objectIndex = DataRow.findIndex(obj => obj.id === id);
        const newObject = { ...DataRow[objectIndex], [element]: value };
        setVasRow(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = newObject;
            return newDataRow;
        });
    };

    /**
        * @description This function is used to change the value of complete row.
        * @param {JSON} row - row of the table.
        * @param {string} id - id of the row.
     */

    function handleObjectChange(row, id) {
        const objectIndex = DataRow.findIndex(obj => obj.id === id);
        setVasRow(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = row;
            return newDataRow;
        });
    }

    function handleAddRowNestedVas() {
        const modifiedRows = [...DataRow];

        const hasEmptyRow = modifiedRows.find(x => x.locode === "" && x.desc === "");

        if (hasEmptyRow) {
            return false;
        }

        modifiedRows.push({
            id: modifiedRows.length + 1,
            locode: "",
            desc: "",
            loStart: "",
            loEnd: "",
            state: false,
        });

        const idModification = modifiedRows.map((item, index) => {
            item.id = index + 1;
            return item
        })

        setVasRow(idModification);
    }


    function handleRemoveRowVas(id) {
        const modifiedRows = [...DataRow]
        const objectIndex = modifiedRows.findIndex(obj => obj.id === id);

        if (objectIndex !== -1) {
            modifiedRows.splice(objectIndex, 1)

            for (let i = 0; i < modifiedRows.length; i++) {
                modifiedRows[i].id = i + 1
            }

            if (modifiedRows.length == 0) {
                modifiedRows.push({
                    id: 1,
                    locode: "",
                    desc: "",
                    loStart: "",
                    loEnd: "",
                    state: false,

                })
            }
            const idModification = modifiedRows.map((item, index) => {
                item.id = index + 1;
                return item
            })

            setVasRow(idModification)
        }

    }


    return (
        <React.Fragment>
            <div>
                <Row>
                    <Col sm="12">
                        <CardText className="mb-0">
                            <Row>
                                <DPAlert
                                    confirm_both={alertShow}
                                    title={"User Master !"}
                                    description={alertDesc}
                                    showCancel={false}
                                    btnColor={"success"}
                                    cancelColor={"danger"}
                                    onConfirm={() => {
                                        setsweetAlertShow(false)
                                    }}
                                    btnYes={"OK"}
                                />
                            </Row>
                            <Row>
                                <Col sm={12} md={12} className="mb-12-sm">
                                    <table style={{ fontSize: "11px" }} id={"locationTable"} >
                                        <thead className="table-light">
                                            <tr>
                                                <th>Code</th>
                                                <th></th>
                                                <th>Description</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th style={{ textAlign: "center" }}>Is Active</th>
                                            </tr>
                                        </thead>
                                        <tbody disabled={true}>
                                            {currentPosts.map((formRow, key) => (
                                                <TableRow
                                                    DataRow={DataRow}
                                                    FormRow={formRow}
                                                    Key={key}
                                                    RemoveRow={handleRemoveRowVas}
                                                    Disabled={disabled}
                                                    AlertShow={setsweetAlertShow}
                                                    AlertDesc={SetAlertDesc}
                                                    menuCode={menuCode}
                                                    CheckAdmin={CheckAdmin}
                                                    changeRowValueChanges={changeRowValueChanges}
                                                    handleObjectChange={handleObjectChange}
                                                />
                                            ))}
                                        </tbody>
                                    </table>
                                    <Row sm={12} md={12} className="mb-4-sm">
                                        <Col>
                                            <Button
                                                onClick={() => {
                                                    handleAddRowNestedVas()
                                                }}
                                                color="success"
                                                className="mt-1"
                                                disabled={disabled == true ? disabled : CheckAdmin}
                                                size="sm"
                                            >
                                                <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
                                            </Button>
                                        </Col>
                                        <Col>
                                            <ReactPaginate
                                                previousLabel={'Previous'}
                                                nextLabel={'Next'}
                                                breakLabel={'...'}
                                                pageClassName="page-item"
                                                pageLinkClassName="page-link"
                                                previousClassName="page-item"
                                                previousLinkClassName="page-link"
                                                nextClassName="page-item"
                                                nextLinkClassName="page-link"
                                                breakClassName="page-item"
                                                breakLinkClassName="page-link"
                                                pageCount={Math.ceil(DataRow.length / postsPerPage)}
                                                pageRangeDisplayed={5}
                                                onPageChange={handlePageClick}
                                                forcePage={currentPage - 1}
                                                renderOnZeroPageCount={null}
                                                activeClassName={'active'}
                                                activeLinkClassName={'page-link'}
                                                containerClassName={'pagination justify-content-end pagination-sm'}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardText>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default UserMasterTab4

const TableRow = ({ DataRow, FormRow, Key, RemoveRow, Disabled, AlertShow, AlertDesc, menuCode, CheckAdmin, changeRowValueChanges, handleObjectChange }) => {
    const ApiURL = window.Links.ApiURL

    const [modal_xlarge, setmodal_xlarge] = useState(false)

    const defaultSorted = [
        {
            dataField: "id",
            order: "asc",
        },
    ]

    const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
        if (CodeValidation(row.LOC_CODE, 1)) {
            getData(row.LOC_CODE)
        } else {
            AlertShow(true)
            AlertDesc("Code already used !")
        }

        setmodal_xlarge(!modal_xlarge)
    }


    async function getData(searchdata) {

        if (searchdata != "") {
            const ApiURL = window.Links.ApiURL
            const authToken = localStorage.getItem("authToken");
            await fetch(`${ApiURL}Locations/SearchCode/${searchdata}`, {
                method: "GET",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${authToken}` },
            }).then(Response => Response.json())
                .then(responseData => {
                    if (responseData.success == true) {
                        const newArray = responseData.data[0]
                        var currentRow = FormRow
                        currentRow.locode = newArray.code
                        currentRow.desc = newArray.name
                        currentRow.isDisabled = true
                        handleObjectChange(currentRow, FormRow.id)

                    } else {
                        var currentRow = FormRow
                        currentRow.locode = ""
                        currentRow.desc = ""
                        currentRow.isDisabled = false
                        handleObjectChange(currentRow, FormRow.id)
                    }
                })
        } else {
            var currentRow = FormRow
            currentRow.locode = ""
            currentRow.desc = ""
            currentRow.isDisabled = false
            handleObjectChange(currentRow, FormRow.id)
        }
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    async function clickSearch() {
        tog_xlarge();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }


    //* Code Validation from repeating*/
    const CodeValidation = (strCode, onRowClick = 0) => {

        var filter = DataRow.filter(function (item) {
            return item.locode == strCode
        })

        if (onRowClick != 0) {
            if (filter.length > 0) {
                return false
            }
        } else {
            if (filter.length > 1) {
                return false
            }
        }

        return true
    }

    function endAfterStart(start, end) {
        var startDate = new Date(start);
        var endDate = new Date(end);

        return endDate.getTime() >= startDate.getTime();
    }

    return (
        <tr key={FormRow.id}>
            <td style={{ width: "200px" }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="text"
                            maxLength="8"
                            id={"loCode" + Key}
                            value={FormRow.locode}
                            disabled={Disabled == true ? Disabled : FormRow.isDisabled}
                            onChange={e => {
                                changeRowValueChanges(e.target.value, FormRow.id, "locode")
                            }}
                            onBlur={e => {
                                if (CodeValidation(e.target.value, 0)) {
                                    getData(e.target.value)
                                } else {
                                    AlertShow(true)
                                    AlertDesc("Code already used !")
                                    changeRowValueChanges("", FormRow.id, "locode")
                                }
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>
            <td>
                <Row className="mb-0">
                    <Col md="12">
                        <Button
                            outline
                            color="success"
                            id={"loSearch" + Key}
                            onClick={clickSearch}
                            disabled={Disabled == true ? Disabled : FormRow.isDisabled}
                            size="sm">
                            <i
                                className="mdi mdi-search-web"
                                style={{ fontSize: "12px" }}
                            ></i>
                        </Button>
                    </Col>
                </Row>
            </td>
            <td style={{ width: "300px" }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Description"
                            textType="text"
                            maxLength="8"
                            id={"loDesc" + Key}
                            value={FormRow.desc}
                            disabled={true}
                            onChange={(e) => {
                                changeRowValueChanges(e.target.value, FormRow.id, "desc")
                            }}
                            onBlur={e => {

                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>
            <td style={{ width: "200px" }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="date"
                            id={"loSdate" + Key}
                            value={FormRow.loStart}
                            disabled={Disabled == true ? Disabled : CheckAdmin}
                            onChange={(e) => {

                                changeRowValueChanges(e.target.value, FormRow.id, "loStart")
                            }}
                            onBlur={e => {
                                if (FormRow.loEnd == "") {

                                    changeRowValueChanges(e.target.value, FormRow.id, "loStart")
                                } else if (endAfterStart(e.target.value, FormRow.loEnd)) {

                                    changeRowValueChanges(e.target.value, FormRow.id, "loStart")
                                } else {
                                    AlertShow(true)
                                    AlertDesc("Start date should not be later than end date !")

                                    changeRowValueChanges("", FormRow.id, "loStart")

                                    changeRowValueChanges("", FormRow.id, "loEnd")
                                }
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>
            <td style={{ width: "200px" }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="date"
                            id={"loEdate" + Key}
                            value={FormRow.loEnd}
                            disabled={Disabled == true ? Disabled : CheckAdmin}
                            onChange={(e) => {

                                changeRowValueChanges(e.target.value, FormRow.id, "loEnd")
                            }}
                            onBlur={e => {
                                if (FormRow.loStart == "") {
                                    AlertShow(true)
                                    AlertDesc("select start date first !")

                                    changeRowValueChanges("", FormRow.id, "loEnd")
                                } else if (endAfterStart(FormRow.loStart, e.target.value)) {

                                    changeRowValueChanges(e.target.value, FormRow.id, "loEnd")
                                } else {
                                    AlertShow(true)
                                    AlertDesc("End date cannot be a day before the Start date !")

                                    changeRowValueChanges("", FormRow.id, "loEnd")
                                }
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>
            <td style={{ width: "80px", margin: "auto" }}>
                <Row className="mb-0">
                    <Col md="12" style={{ textAlign: "center" }}>
                        <Switch
                            uncheckedIcon={<Offsymbol />}
                            checkedIcon={<OnSymbol />}
                            disabled={Disabled == true ? Disabled : CheckAdmin}
                            onColor="#626ed4"
                            height={23}
                            handleDiameter={15}
                            onChange={(e) => {
                                // SetStatus(!status)
                                changeRowValueChanges(e, FormRow.id, "state")
                            }}
                            checked={FormRow.state}
                            id={"loStatus" + Key}
                        />
                    </Col>
                </Row>
            </td>
            <td>
                <Row className="mb-0">
                    <Col md="1">
                        <Button
                            outline
                            disabled={Disabled == true ? Disabled : CheckAdmin}
                            color="danger"
                            id={"vasDelete" + Key}
                            onClick={e => {
                                RemoveRow(FormRow.id)
                            }}
                            size="sm">
                            <i
                                className="mdi mdi-delete"
                                style={{ fontSize: "12px" }}
                            ></i>
                        </Button>
                    </Col>{" "}

                    <DPSearchBoxDynamic
                        searchData={[]}
                        columns={[]}
                        defaultSorted={defaultSorted}
                        mainTitle={"Location Detail Search"}
                        SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                        isOpen={modal_xlarge}
                        toggle={tog_xlarge}
                        getSelect={Hed_SelectRowSearch}
                        APIURL={ApiURL}
                        URLPath={"LOCATION"}
                        MenuCode={menuCode}
                        KeyVal={"USE"}
                        searchBy={"LOC_CODE"}
                        FilterStr={"a"}
                    />

                </Row>
            </td>
        </tr>
    )
}

